<script>
  import { appSession, appConstants } from "../stores/app.js";

  // resolve jumpseat request
  export function GetJumpseatRequest(jumpseatRequestId, queryString = "") {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      let url = $appConstants.apiURLBase + "jumpseatrequests/" + jumpseatRequestId;
      if (queryString != "") url += "?" + queryString;
      xhr.open("GET", url);

      xhr.setRequestHeader("Authorization", "Bearer " + $appSession.authorisationToken);
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      xhr.send(null);
      xhr.onload = () => {
        try {
          if (xhr.status < 200 || xhr.status >= 300) throw "NetworkError";
          let response = JSON.parse(xhr.response);
          if (response.success != true) throw response.errormessage;
          resolve(response.data);
        } catch (e) {
          reject(e);
        }
      };
      xhr.onerror = () => {
        reject("NetworkError");
      };
    });
  }

  // resolve list of jumpseat requests
  export function GetJumpseatRequestList(queryString = "") {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      let url = $appConstants.apiURLBase + "jumpseatrequests";
      if (queryString != "") url += "?" + queryString;
      xhr.open("GET", url);
      xhr.setRequestHeader("Authorization", "Bearer " + $appSession.authorisationToken);
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      xhr.send(null);
      xhr.onload = () => {
        try {
          if (xhr.status < 200 || xhr.status >= 300) throw "NetworkError";
          let response = JSON.parse(xhr.response);
          if (response.success != true) throw response.errormessage;
          resolve(response.data);
        } catch (e) {
          reject(e);
        }
      };
      xhr.onerror = () => {
        reject("NetworkError");
      };
    });
  }

  // post a new jumpseat request
  export function PostJumpseatRequest(fields) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("POST", $appConstants.apiURLBase + "jumpseatrequests");
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      xhr.setRequestHeader("Authorization", "Bearer " + $appSession.authorisationToken);
      xhr.send(JSON.stringify({ fields: fields }));
      xhr.onload = () => {
        try {
          if (xhr.status < 200 || xhr.status >= 300) throw "NetworkError";

          console.log(xhr.response)
          let response = JSON.parse(xhr.response);
          if (response.success != true) throw response.errormessage;
          resolve(response.emptylegenquiryid);
        } catch (error) {
          reject(error);
        }
      };
      xhr.onerror = () => {
        reject("NetworkError");
      };
    });
  }

  // put an existing jumpseat request
  export function PutJumpseatRequest(jumpseatRequestId, fields) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("PUT", $appConstants.apiURLBase + "jumpseatrequests/" + jumpseatRequestId);
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      xhr.setRequestHeader("Authorization", "Bearer " + $appSession.authorisationToken);
      xhr.send(JSON.stringify({ fields: fields }));
      xhr.onload = () => {
        try {
          if (xhr.status < 200 || xhr.status >= 300) throw "NetworkError";
          let response = JSON.parse(xhr.response);
          if (response.success != true) throw response.errormessage;
          resolve();
        } catch (error) {
          reject(error);
        }
      };
      xhr.onerror = () => {
        reject("NetworkError");
      };
    });
  }
</script>
